import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCategoryShowcaseWithProducts } from "../../store/actions/categoryShowcase";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";
import Loading from "../../components/shared/Loading";
import VibrantProductCard from "../../components/VibrantProductCard";
import SEO from "../../components/shared/SEO";
import {
  generatePageTitle,
  generateMetaDescription,
  generateKeywords,
} from "../../helpers/seo";

class CategoryShowcase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      sortBy: "default",
    };
  }
  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.fetchCategoryShowcaseWithProducts(id);
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props.match.params;
    const prevId = prevProps.match.params.id;

    if (id !== prevId) {
      this.props.fetchCategoryShowcaseWithProducts(id);
    }
  }

  getFilteredAndSortedProducts = () => {
    const { currentShowcase } = this.props.categoryShowcase;
    const { searchTerm, sortBy } = this.state;

    if (!currentShowcase || !currentShowcase.products || currentShowcase.products.length === 0) {
      return [];
    }

    let filtered = [...currentShowcase.products];

    if (searchTerm) {
      filtered = filtered.filter(
        (product) =>
          product.name &&
          product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    switch (sortBy) {
      case "featured":
        filtered = filtered.filter((product) => product.featured);
        break;
      case "deals":
        filtered = filtered.filter((product) => product.isDeal);
        break;
      case "new":
        filtered = filtered.filter((product) => {
          if (product.isNewProduct) return true;
          if (product.created_at) {
            const now = new Date();
            const createdDate = new Date(product.created_at);
            const daysDifference = (now - createdDate) / (1000 * 60 * 60 * 24);
            return daysDifference <= 7;
          }
          return false;
        });
        break;
      case "discounted":
        filtered = filtered.filter(
          (product) => product.sale_price && product.sale_price < product.price
        );
        break;
      case "price_asc":
        filtered.sort((a, b) => {
          const priceA = a.sale_price || a.price || 0;
          const priceB = b.sale_price || b.price || 0;
          return priceA - priceB;
        });
        break;
      case "price_desc":
        filtered.sort((a, b) => {
          const priceA = a.sale_price || a.price || 0;
          const priceB = b.sale_price || b.price || 0;
          return priceB - priceA;
        });
        break;
      case "newest":
        filtered.sort((a, b) => {
          const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
          const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
          return dateB - dateA;
        });
        break;
      default:
        break;
    }

    return filtered;
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleSortChange = (sortBy) => {
    this.setState({ sortBy });
  };

  getButtonStyle = (activeSort) => ({
    backgroundColor: this.state.sortBy === activeSort ? "#88c000" : "white",
    color: this.state.sortBy === activeSort ? "white" : "#666",
    border:
      this.state.sortBy === activeSort ? "1px solid #88c000" : "1px solid #ddd",
    borderRadius: "20px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    minWidth: "auto",
    whiteSpace: "nowrap",
    marginRight: "4px",
    marginBottom: "6px",
  });

  handleButtonHover = (e, activeSort, isEntering) => {
    if (this.state.sortBy !== activeSort) {
      if (isEntering) {
        e.target.style.backgroundColor = "#f0f8e8";
        e.target.style.borderColor = "#88c000";
        e.target.style.color = "#88c000";
      } else {
        e.target.style.backgroundColor = "white";
        e.target.style.borderColor = "#ddd";
        e.target.style.color = "#666";
      }
    }
  };

  render() {
    const { categoryShowcase, setting } = this.props;
    const { currentShowcase, loading } = categoryShowcase;
    const { searchTerm, sortBy } = this.state;

    // Get filtered and sorted products
    const displayProducts = this.getFilteredAndSortedProducts();
    const totalProducts = currentShowcase && currentShowcase.products ? currentShowcase.products.length : 0;

    // SEO data for category showcase page
    const showcaseSEO = currentShowcase
      ? {
          title: generatePageTitle(
            "showcase",
            currentShowcase,
            setting && setting.setting && setting.setting.title
          ),
          description: generateMetaDescription(
            "showcase",
            currentShowcase,
            setting && setting.setting && setting.setting.title
          ),
          keywords: generateKeywords("showcase", currentShowcase, [
            "vitrin",
            "ürünler",
            "koleksiyon",
          ]),
          type: "website",
          url: `/vitrin/${currentShowcase.id}`,
        }
      : null;

    return (
      <React.Fragment>
        {showcaseSEO && <SEO {...showcaseSEO} />}
        <PageTitle title={currentShowcase && currentShowcase.title} />

        <div className="container-fluid" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
          {/* Full Width Filter Section */}
          <div className="row" style={{ marginTop: 20 }}>
            <div className="col-12">
              {/* Search and Sort Controls */}
              <div
                style={{
                  background: "linear-gradient(135deg, #f0f8e8 0%, #fff 100%)",
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  padding: "20px 15px",
                  marginBottom: 10,
                }}
              >
                {/* Search and Filter Section */}
                <div className="row">
                  <div className="col-lg-4 col-md-5 col-sm-12 mb-3">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          style={{
                            backgroundColor: "#88c000",
                            color: "white",
                            border: "none",
                          }}
                        >
                          <FontAwesomeIcon icon={["fas", "search"]} />
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ne aramıştınız?"
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        style={{
                          border: "1px solid #88c000",
                          borderLeft: "none",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12">
                    <div className="d-flex flex-wrap align-items-center justify-content-lg-end">
                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("featured")}
                        style={this.getButtonStyle("featured")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "featured", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "featured", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "star"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Öne çıkan
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("deals")}
                        style={this.getButtonStyle("deals")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "deals", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "deals", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "bolt"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fırsat Ürünü
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("new")}
                        style={this.getButtonStyle("new")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "new", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "new", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "tag"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Yeni ürün
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("discounted")}
                        style={this.getButtonStyle("discounted")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "discounted", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "discounted", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "percent"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        İndirimli ürünler
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("price_asc")}
                        style={this.getButtonStyle("price_asc")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "price_asc", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "price_asc", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "sort-amount-up"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fiyat artan
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("price_desc")}
                        style={this.getButtonStyle("price_desc")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "price_desc", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "price_desc", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "sort-amount-down"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Fiyat azalan
                      </button>

                      <button
                        className="btn btn-sm"
                        onClick={() => this.handleSortChange("newest")}
                        style={this.getButtonStyle("newest")}
                        onMouseEnter={(e) =>
                          this.handleButtonHover(e, "newest", true)
                        }
                        onMouseLeave={(e) =>
                          this.handleButtonHover(e, "newest", false)
                        }
                      >
                        <FontAwesomeIcon
                          icon={["fas", "clock"]}
                          style={{ marginRight: "5px", fontSize: "11px" }}
                        />
                        Yeni eklenenler
                      </button>

                      {(searchTerm || sortBy !== "default") && (
                        <button
                          className="btn btn-sm"
                          onClick={() => {
                            this.setState({
                              searchTerm: "",
                              sortBy: "default",
                            });
                          }}
                          style={{
                            backgroundColor: "#ff6b6b",
                            color: "white",
                            border: "1px solid #ff6b6b",
                            borderRadius: "20px",
                            padding: "6px 12px",
                            fontSize: "12px",
                            fontWeight: "500",
                            transition: "all 0.3s ease",
                            minWidth: "auto",
                            whiteSpace: "nowrap",
                            marginRight: "4px",
                            marginBottom: "6px",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#ff5252";
                            e.target.style.borderColor = "#ff5252";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#ff6b6b";
                            e.target.style.borderColor = "#ff6b6b";
                          }}
                        >
                          <FontAwesomeIcon
                            icon={["fas", "times"]}
                            style={{ marginRight: "5px", fontSize: "11px" }}
                          />
                          Temizle
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Area with Sidebar */}
          <div className="row">
            {/* Left Sidebar */}
            <div className="col-md-3">
              <CartWidget />
              <CategoriesWidget />
            </div>

            {/* Products Grid */}
            <div className="col-md-9">
              <div className="row">
                {loading ? (
                  <div className="col-12 text-center py-5">
                    <Loading />
                  </div>
                ) : displayProducts.length > 0 ? (
                  displayProducts.map((product, i) => (
                    <div
                      className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4"
                      key={product._id || i}
                    >
                      <VibrantProductCard {...product} />
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <div className="alert alert-info">
                      <h5>Ürün Bulunamadı</h5>
                      <p>
                        Aradığınız kriterlere uygun ürün bulunamadı. Lütfen
                        filtreleri değiştirip tekrar deneyin.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Results Count */}
              {!loading && displayProducts.length > 0 && (
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="alert alert-light text-center">
                      <strong>{displayProducts.length}</strong> ürün
                      gösteriliyor
                      {totalProducts !== displayProducts.length && (
                        <span> (toplam {totalProducts} ürün içinden)</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ categoryShowcase, setting }) => {
  return { categoryShowcase, setting };
};

const mapDispatchToProps = {
  fetchCategoryShowcaseWithProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryShowcase);



// WEBPACK FOOTER //
// ./src/routers/CategoryShowcase/index.js